module.exports = __webpack_public_path__ + "img/web9.12ae2441.png";